var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFileText = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PRIVACY"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.05 8.70041L17.2333 12.1837C16.5333 15.1921 15.15 16.4087 12.55 16.1587C12.1333 16.1254 11.6833 16.0504 11.2 15.9337L9.79999 15.6004C6.32499 14.7754 5.24999 13.0587 6.06665 9.57541L6.88332 6.08375C7.04999 5.37541 7.24999 4.75875 7.49999 4.25041C8.47499 2.23375 10.1333 1.69208 12.9167 2.35041L14.3083 2.67541C17.8 3.49208 18.8667 5.21708 18.05 8.70041Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5331 7.10833L14.5748 8.13333M9.71646 10.3333L12.1331 10.95M12.5498 16.1583C12.0331 16.5083 11.3831 16.8 10.5915 17.0583L9.2748 17.4917C5.96646 18.5583 4.2248 17.6667 3.1498 14.3583L2.08313 11.0667C1.01646 7.75833 1.8998 6.00833 5.20813 4.94167L6.5248 4.50833C6.86646 4.4 7.19146 4.30833 7.4998 4.25C7.2498 4.75833 7.0498 5.375 6.88313 6.08333L6.06646 9.575C5.2498 13.0583 6.3248 14.775 9.7998 15.6L11.1998 15.9333C11.6831 16.05 12.1331 16.125 12.5498 16.1583Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileText, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file-text.91aa9da9.svg";
export { ForwardRef as ReactComponent };